import { render, staticRenderFns } from "./DemoAccountBanners.vue?vue&type=template&id=0b9db5a8&scoped=true"
import script from "./DemoAccountBanners.vue?vue&type=script&lang=js"
export * from "./DemoAccountBanners.vue?vue&type=script&lang=js"
import style0 from "./DemoAccountBanners.vue?vue&type=style&index=0&id=0b9db5a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9db5a8",
  null
  
)

export default component.exports